export enum CategoryType {
  Product = 'Product',
  Service = 'Service'
}
